import React from 'react';

export const ShieldEmptySpot = (): React.ReactElement => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="security">
      <path
        id="Color"
        d="M24.6943 43.8424C24.4786 43.9498 24.2409 44.0057 24 44.0057C23.7591 44.0057 23.5214 43.9498 23.3057 43.8424C20.2329 42.315 8 35.2419 8 21.9107V11.4175C8 10.6507 8.68612 10.0205 9.56782 9.96692C17.7174 9.47095 20.4425 6.83669 22.6623 4.52298C23.3244 3.83298 24.5445 3.82444 25.2182 4.50513C27.5032 6.81496 30.2205 9.36928 38.4314 9.86524C39.3131 9.91802 40 10.549 40 11.3151V21.8121C40 35.2302 27.767 42.3134 24.6943 43.8424Z"
        fill="#737B84"
      />
    </g>
  </svg>
);
